import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { Facturedetail } from 'src/app/entity/Facture';
import { FacturedetailService } from 'src/app/service/facture.detail.service';

@Component({
  selector: 'app-publicite',
  templateUrl: './publicite.component.html',
  styleUrls: ['./publicite.component.css']
})
export class PubliciteComponent implements OnInit ,OnChanges{

  produits: Facturedetail[];
  cols: any[];

    columns: any[];
    @Input() index:number;

  constructor(private factureDetailService: FacturedetailService) { }

  ngOnInit() {
 
    this.cols = [
      { field: 'Entreprise', header: 'idfacture.client.raisonSocial' },
      { field: 'Produits', header: 'designation' }, 
      { field: 'Quantité', header: 'quantite' }
      , 
      { field: 'Stand', header: 'idfacture.client.standList' }
  ];
  
  this.columns = this.cols.map(col => ({title: col.header, dataKey: col.field}));


  

  }
  ngOnChanges(changes: SimpleChanges): void {
    if(this.index==1 && !this.produits){
      this.factureDetailService.findPublicite().subscribe(result=>{
        this.produits=result;
     
     
         }
           
         );
    }
 
  }

exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.getCars());
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "primengTable");
    });
}
saveAsExcelFile(buffer: any, fileName: string): void {
  import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
          type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  });
}
getCars() {
  let cars = [];
  for(let car of this.produits) {
    let car1 = new Publicite();
    car1.Client = car.idfacture.client.raisonSocial.toString();
    car1.Designation=car.designation;
    car1.Quantite=car.quantite;
    
         cars.push(car1);
     }
     return cars;
   }
   }
   export class Publicite {
    Client:string;
     Designation: string;
    
     Quantite: number;
    
    
    
   
   }